export const API_URL = process.env.REACT_APP_API_URL;
export const API_V2_URL = process.env.REACT_APP_API_V2_URL;
export const NFE_URL = process.env.REACT_APP_NFE_URL;
